/**
 * Firebase Analytics event names (snake_case, ≤40 chars).
 * Canonical list — see docs/analytics.md for trigger definitions.
 */

export const AnalyticsEvents = {
  GAME_LAUNCH: "game_launch",
  RUN_START: "run_start",
  RUN_RESUMED: "run_resumed",
  FLASK_BROKEN: "flask_broken",
  OVERFLOW: "overflow",
  FALL_START: "fall_start",
  FALL_COUNTDOWN_FINISHED: "fall_countdown_finished",
  SKY_BG_RESOLVED: "sky_bg_resolved",
  FALL_COMPLETED: "fall_completed",
  FALL_COMPLETED_EMPTY: "fall_completed_empty",
  MERGE_START: "merge_start",
  MERGE_COMPLETED: "merge_completed",
  MERGE_COMPLETED_EMPTY: "merge_completed_empty",
  MERGE_ALERT: "merge_alert",
  DROP_ALL: "drop_all",
  PUZZLE_PIECE_REVEALED: "puzzle_piece_revealed",
  PLAY_AGAIN: "play_again",
  FREE_SHAKE: "free_shake",
  PAID_SHAKE: "paid_shake",
  FREE_BOMB_CELL: "free_bomb_cell",
  PAID_BOMB_CELL: "paid_bomb_cell",
  FREE_BOMB_TRIPLE: "free_bomb_triple",
  PAID_BOMB_TRIPLE: "paid_bomb_triple",
  PAID_FIX: "paid_fix",
  FREE_MINIMIZE: "free_minimize",
  PAID_MINIMIZE: "paid_minimize",
  REVIVE_OFFERED: "revive_offered",
  REVIVE_COMPLETED: "revive_completed",
  REVIVE_SKIPPED: "revive_skipped",
  BOULDER_HIT: "boulder_hit",
  BOULDER_BLOCKED: "boulder_blocked",
  PLAYER_PAUSE: "player_pause",
  PLAYER_RESUME: "player_resume",
  MUSIC_OFF: "music_off",
  MUSIC_ON: "music_on",
  SOUND_OFF: "sound_off",
  SOUND_ON: "sound_on",
  CHEAT_DIALOG_OPEN: "cheat_dialog_open",
  CHEAT_SUCCESS: "cheat_success",
  CHEAT_FAIL: "cheat_fail",
  DRAGON_MERGE: "dragon_merge",
  VICTORY_SHOWN: "victory_shown",
  VICTORY_FEEDBACK: "victory_feedback",
  VICTORY_CONTINUE: "victory_continue",
  PERF_LOW_FPS: "perf_low_fps",
  DAILY_OPENED: "daily_opened",
  DAILY_CLAIMED: "daily_claimed",
  WHEEL_OPENED: "wheel_opened",
  WHEEL_SPIN_FREE: "wheel_spin_free",
  WHEEL_SPIN_AD: "wheel_spin_ad",
  GEMS_AD_OPENED: "gems_ad_opened",
  GEMS_AD_COMPLETED: "gems_ad_completed",
};

/** @param {number} chainIndex 0-based evolution chain index */
export function discoveredTierEventName(chainIndex) {
  var idx = Math.max(0, Math.floor(Number(chainIndex) || 0));
  return "discovered_tier_" + idx;
}